import qs from 'query-string'
import Button from '@/components/Button'
import Input from '@/components/Input'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import { zheka2 } from '@/images'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import style from '../styles/reset.module.scss'
import { useFormik } from 'formik'
import { api } from '@/api'
import { GxForm } from '@garpix/garpix-web-components-react'
import { resetPasswordSetPasswordSchema } from '@/utils/schemesFormik'
import Spinner from '@/components/Spinner/Spinner'
import ErrorAllText from '@/components/ErrorText/AllErros'

const SetPassword = (): React.ReactElement => {
  const [isSuccess, setSuccess] = useState(false)
  const location = useLocation()
  const page = usePage()
  const { config } = page?.init_state?.global
  const search = location.search
  const params = qs.parse(search)
  const login = params?.USER_LOGIN ?? ''
  const userCheckword = params?.USER_CHECKWORD ?? ''
  const userLogin = params?.USER_LOGIN ?? ''

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: resetPasswordSetPasswordSchema,
    initialValues: {
      login: userLogin,
      password: '',
      password2: '',
      checkword: userCheckword,
      apiError: ''
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit (values, { setSubmitting, setErrors }) {
      api
        .restorePasswordSetPassword(values)
        .then((data) => {
          setSuccess(true)
        })
        .catch((err: any) => {
          setErrors({ apiError: err?.response?.data?.errorText })
          setSubmitting(false)
        })
    }
  })

  const onSubmit = formik.submitForm

  if (isSuccess) {
    return (
      <div className={style.reset_flex}>
        <div className={style.reset_left}>
          <Title type='h2' theme='h3' className={style.reset__title}>
            Пароль успешно изменен!
          </Title>
          <p className={style.reset__text}>
            Новый пароль был создан для учетной записи{' '}
            <span className={style.reset__mail}>{login}</span>.
          </p>
          <Button
            wide
            size='extralarge'
            highlight
            className={style.reset__field}
            href={config.authorization}
          >
            Вернуться к авторизации
          </Button>

          <Button
            wide
            size='extralarge'
            outline
            href={config.home_url}
            className={style.reset__field}
          >
            На главную
          </Button>
        </div>
        <img
          src={zheka2}
          width='435px'
          height='600px'
          alt=''
          className={style.reset__image}
        />
      </div>
    )
  }
  return (
    <div className={style.reset}>
      <Title type='h2' theme='h3' className={style.reset__title}>
        Сбросить пароль
      </Title>
      <p className={style.reset__text}>
        Придумай новый пароль для учетной записи{' '}
        <span className={style.reset__mail}>{login}</span>. Пароль должен быть
        не менее 8 знаков.
      </p>
      <GxForm onGx-submit={onSubmit}>
        <Input
          name='password'
          label='Новый пароль:'
          type='password'
          placeholder='Минимум 8 символов'
          required
          autocomplete='new-password'
          className={style.reset__field}
          onGx-input={formik.handleChange}
          error={formik.errors.password}
        />
        <Input
          name='password2'
          label='Повтори новый пароль:'
          type='password'
          required
          autocomplete='new-password'
          className={style.reset__field}
          onGx-input={formik.handleChange}
          error={formik.errors.password2}
        />
        <div>
          {formik?.errors?.apiError === ''
            ? null
            : (
              <ErrorAllText text={formik.errors.apiError} />
              )}
        </div>
        <Button
          disabled={formik.isSubmitting}
          type='submit'
          wide
          size='extralarge'
          highlight
        >
          {formik.isSubmitting ? <Spinner /> : 'Отправить'}
        </Button>
      </GxForm>
    </div>
  )
}

export default SetPassword
